/* =====================================================================
   PB SIGNALER — hvad kunden har kigget på, søgt efter og hvor kunden kom fra.
   Bruges af kurvens fri fragt-forslag til at vælge den vare kunden helst vil have.
   • Alt bliver i kundens egen browser (intet sendes nogen steder hen).
   • Gemmes kun når kunden har sagt ja til "præferencer" i cookie-banneret
     (Shopify Customer Privacy API). Uden samtykke bruges kun den side kunden står på.
   • Holdes kort: de seneste 30 viste varer, 20 kategorier, 15 søgninger — højst 30 dage.
   ===================================================================== */
(function () {
  'use strict';
  var w = window, d = document, KEY = 'pbSig1', DAY = 864e5, now = Date.now(), mem = null;

  function allowed() {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy;
      if (cp && typeof cp.preferencesProcessingAllowed === 'function') return !!cp.preferencesProcessingAllowed();
    } catch (e) {}
    return false;
  }
  function load() {
    if (mem) return mem;
    try { if (allowed()) mem = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!mem || typeof mem !== 'object') mem = {};
    mem.v = mem.v || []; mem.c = mem.c || []; mem.s = mem.s || []; mem.ref = mem.ref || null;
    return mem;
  }
  function save() { if (!allowed()) return; try { localStorage.setItem(KEY, JSON.stringify(mem)); } catch (e) {} }
  function keep(a, max, days) { var lim = now - days * DAY; return a.filter(function (x) { return x && x.t > lim; }).slice(-max); }
  function ctx() { try { return JSON.parse((d.getElementById('pb-ctx') || {}).textContent || '{}') || {}; } catch (e) { return {}; } }

  function record() {
    var m = load(), c = ctx();
    if (c.t === 'p' && c.pid) {
      m.v = m.v.filter(function (x) { return x.id !== c.pid; });
      m.v.push({ id: c.pid, g: c.g || '', pt: c.pt || '', ti: c.ti || '', pr: c.pr || 0, t: now });
    } else if (c.t === 'c' && c.g) {
      m.c.push({ g: c.g, t: now });
    } else if (c.t === 's' && c.q) {
      m.s.push({ q: String(c.q).toLowerCase().slice(0, 60), t: now });
    }
    /* hvor kom kunden fra — huskes fra første side i besøget */
    var first = false;
    try { first = !sessionStorage.getItem('pbSigS'); sessionStorage.setItem('pbSigS', '1'); } catch (e) {}
    if (first) {
      var u, rh = '';
      try { u = new URL(location.href); } catch (e) { u = null; }
      try { rh = d.referrer ? new URL(d.referrer).host : ''; } catch (e) {}
      var q = function (k) { return (u && u.searchParams.get(k)) || ''; };
      var ext = rh && rh !== location.host;
      if (ext || q('utm_source') || q('gclid') || q('msclkid') || q('fbclid')) {
        m.ref = { host: rh, src: q('utm_source'), med: q('utm_medium'), cmp: q('utm_campaign'),
                  ads: !!(q('gclid') || q('msclkid') || q('fbclid')), land: c, t: now };
      }
    }
    m.v = keep(m.v, 30, 30); m.c = keep(m.c, 20, 30); m.s = keep(m.s, 15, 30);
    if (m.ref && m.ref.t < now - 30 * DAY) m.ref = null;
    save();
  }

  w.PB = w.PB || {};
  PB.signals = { get: load, allowed: allowed };

  /* samtykke: indlæs Shopifys privacy-API, gem først når der er sagt ja */
  if (w.Shopify && typeof w.Shopify.loadFeatures === 'function') {
    try { w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { mem = null; record(); }); }
    catch (e) { record(); }
  } else {
    record();
  }
  d.addEventListener('visitorConsentCollected', function () { save(); });
})();
